export const RATE_IDS = {
  DOMESTIC_GLS_STANDARD: 'sh_gls_standard',
  DOMESTIC_DHL_EXPRESS: 'sh_dhl_express',
};
